import React from "react";
import RunningStage from "../stages/RunningStage";
import StagePageLayout from "./StagePageLayout";

export default function WalkingStagePage({ stage, onDone }) {
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <RunningStage data={stage.data} onDone={onDone} />
    </StagePageLayout>
  );
}
